import { EntityId, EntityName } from '@models/entity';
import { blogPageFormHelper } from './formHelpers/blogPageFormHelper';
import { pressRoomFormHelper } from './formHelpers/pressRoomFormHelper';
import { successStoryFormHelper } from './formHelpers/successStoryFormHelper';
import { whitePaperFormHelper } from './formHelpers/whitePaperFormHelper';
import { ArticleId, ArticleName } from '@models/article';
import { ArticleForm as ArticleFormType } from '@models/articleForm';
import { glossaryFormHelper } from './formHelpers/glossaryFormHelper';
import { BlogArticle } from '@models/blog';
import { PressRelease } from '@models/pressRelease';
import { BlogPill } from '@models/blogCards';

interface ArticleSetting {
    form: ArticleFormType;
    entityId: ArticleId;
}

export const articleTypeSettings: Record<ArticleName, ArticleSetting> = {
    [EntityName.PressReleaseArticle]: {
        form: pressRoomFormHelper,
        entityId: EntityId.PressReleaseArticle,
    },
    [EntityName.BlogArticle]: {
        form: blogPageFormHelper,
        entityId: EntityId.BlogArticle,
    },
    [EntityName.SuccessStoryArticle]: {
        form: successStoryFormHelper,
        entityId: EntityId.SuccessStoryArticle,
    },
    [EntityName.WhitePaperArticle]: {
        form: whitePaperFormHelper,
        entityId: EntityId.WhitePaperArticle,
    },
    [EntityName.GlossaryArticle]: {
        form: glossaryFormHelper,
        entityId: EntityId.GlossaryArticle,
    },
};

const hasCategory = (article: BlogArticle | PressRelease): article is BlogArticle =>
    article && 'category' in article && article.category !== null && article.category !== undefined;

export const getPillData = (article: BlogArticle | PressRelease, blogTagLinkPrefix: string, categoryBlogLink: string): BlogPill | undefined => {
    const primaryTag = article.tags.find((tag) => tag.isPrimary);
    return primaryTag ? {
        name: primaryTag.name,
        link: `${blogTagLinkPrefix}${primaryTag.slug}`,
    } : hasCategory(article) && article.category
        ? {
            link: `${categoryBlogLink}${article.category.slug}`,
            name: article.category.name,
        }
        : undefined;
};
